import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { combinedSettingsSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  const captionsSelector = combinedSettingsSelector<{ add: string; edit: string }>(TargetSelector.Entity, [
    { name: "addReviewCaption", prop: "add" },
    { name: "editReviewCaption", prop: "edit" }
  ]);

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const captions = captionsSelector(state, props);

    const product = localState.product!;
    return {
      ...props,
      addCaption: captions.add,
      apiInfo: apiInfoSelector(state, props),
      canReview: localState.canReview,
      editCaption: captions.edit,

      product,
      reloadKey: product.userReview
        ? product.userReview.lastModifiedOnDate ?? product.userReview.createdOnDate
        : localState.product!.id
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
